<template>
  <a href="https://embl.org" target="_blank">
    <img src="./img/embl.png" alt="EMBL" title="EMBL">
  </a>
</template>
